// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-with-indicator-container {
  width: 100%;
  position: relative;
  --input-side-padding: 20px;
  --input-border-radius: 8px;
  --icon-width: 25px;
  --icon-side-offset: 16px;
}

.input-with-indicator-container .indicator-container {
  position: absolute;
  top: -1px; /* input border-width */
  left: 0;
  right: 0;
  display: inline-block;

  height: calc(var(--input-height) + 1px);
  border: 1px solid transparent;
  border-radius: calc(var(--input-border-radius) - 0.5px);
  overflow: hidden;
}

.input-with-indicator-container .indicator-container .indicator {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: inline-block;
  height: 4px;
  z-index: 1;
}

.input-with-indicator-container .indicator.error {
  background-color: var(--input-indicator-color-error);
}

.input-with-indicator-container .indicator.focus {
  background-color: var(--input-indicator-color-focus);
}

.input-with-indicator-container .indicator.valid {
  background-color: var(--input-indicator-color-valid);
}

.input-with-indicator-container .icon-container {
  position: absolute;
  top: 0;
  right: var(--icon-side-offset);
  padding-left: var(--icon-side-offset);
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--input-height);
}

.input-with-indicator-container input {
  position: relative;
  height: var(--input-height);
  width: 100%;
  background-color: var(--input-background-color);

  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: -0.384px;

  border: 1px solid var(--input-border-color);
  border-radius: var(--input-border-radius);
  padding: 0 var(--input-side-padding);
  outline: none;
  box-sizing: border-box;
}

.input-with-indicator-container input::placeholder {
  color: var(--input-placeholder-color);
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
}

.input-with-indicator-container .cvv-tooltip-container {
  position: relative;
  display: flex;
  z-index: 999;
}

@keyframes cv-tooltip-ani {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.input-with-indicator-container .cvv-tooltip-container .cvv-tooltip {
  position: absolute;
  left: 47px;
  bottom: -129px;
  width: 287px;
  height: 335px;
  background: white;
  padding: 64px 30px 30px;
  justify-content: center;
  text-align: center;
  white-space: pre-line;
  font-weight: 700;
  pointer-events: none;
  margin-left: 10px;

  animation: cvv-tootlip-ani 0.5s forwards;
}

/* custom */
@media (max-width: 980px) {
  .input-with-indicator-container .cvv-tooltip-container .cvv-tooltip {
    left: -296px;
  }
}

/* custom */
@media (max-width: 400px) {
  .input-with-indicator-container .cvv-tooltip-container .cvv-tooltip {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.input.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;EAC1B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,uBAAuB;EAClC,OAAO;EACP,QAAQ;EACR,qBAAqB;;EAErB,uCAAuC;EACvC,6BAA6B;EAC7B,uDAAuD;EACvD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,8BAA8B;EAC9B,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,+CAA+C;;EAE/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;;EAExB,2CAA2C;EAC3C,yCAAyC;EACzC,oCAAoC;EACpC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;;EAEjB,wCAAwC;AAC1C;;AAEA,WAAW;AACX;EACE;IACE,YAAY;EACd;AACF;;AAEA,WAAW;AACX;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".input-with-indicator-container {\n  width: 100%;\n  position: relative;\n  --input-side-padding: 20px;\n  --input-border-radius: 8px;\n  --icon-width: 25px;\n  --icon-side-offset: 16px;\n}\n\n.input-with-indicator-container .indicator-container {\n  position: absolute;\n  top: -1px; /* input border-width */\n  left: 0;\n  right: 0;\n  display: inline-block;\n\n  height: calc(var(--input-height) + 1px);\n  border: 1px solid transparent;\n  border-radius: calc(var(--input-border-radius) - 0.5px);\n  overflow: hidden;\n}\n\n.input-with-indicator-container .indicator-container .indicator {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: inline-block;\n  height: 4px;\n  z-index: 1;\n}\n\n.input-with-indicator-container .indicator.error {\n  background-color: var(--input-indicator-color-error);\n}\n\n.input-with-indicator-container .indicator.focus {\n  background-color: var(--input-indicator-color-focus);\n}\n\n.input-with-indicator-container .indicator.valid {\n  background-color: var(--input-indicator-color-valid);\n}\n\n.input-with-indicator-container .icon-container {\n  position: absolute;\n  top: 0;\n  right: var(--icon-side-offset);\n  padding-left: var(--icon-side-offset);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: var(--input-height);\n}\n\n.input-with-indicator-container input {\n  position: relative;\n  height: var(--input-height);\n  width: 100%;\n  background-color: var(--input-background-color);\n\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 140%;\n  letter-spacing: -0.384px;\n\n  border: 1px solid var(--input-border-color);\n  border-radius: var(--input-border-radius);\n  padding: 0 var(--input-side-padding);\n  outline: none;\n  box-sizing: border-box;\n}\n\n.input-with-indicator-container input::placeholder {\n  color: var(--input-placeholder-color);\n  font-size: 17px;\n  font-weight: 400;\n  line-height: 22px;\n}\n\n.input-with-indicator-container .cvv-tooltip-container {\n  position: relative;\n  display: flex;\n  z-index: 999;\n}\n\n@keyframes cv-tooltip-ani {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.input-with-indicator-container .cvv-tooltip-container .cvv-tooltip {\n  position: absolute;\n  left: 47px;\n  bottom: -129px;\n  width: 287px;\n  height: 335px;\n  background: white;\n  padding: 64px 30px 30px;\n  justify-content: center;\n  text-align: center;\n  white-space: pre-line;\n  font-weight: 700;\n  pointer-events: none;\n  margin-left: 10px;\n\n  animation: cvv-tootlip-ani 0.5s forwards;\n}\n\n/* custom */\n@media (max-width: 980px) {\n  .input-with-indicator-container .cvv-tooltip-container .cvv-tooltip {\n    left: -296px;\n  }\n}\n\n/* custom */\n@media (max-width: 400px) {\n  .input-with-indicator-container .cvv-tooltip-container .cvv-tooltip {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
